<template>
  <div class="km-hero">
    <Carousel autoplay :height="carouselHeight" :autoplay-speed="5000" v-model="activeIndex" loop arrow="never" :dots="'none'">
      <CarouselItem v-for="(item, index) in carouselItems" :key="index">
        <div class="hero-slide">
          <!-- 背景图 -->
          <div class="hero-bg">
            <img :src="item.src" :alt="item.alt" class="hero-bg-img" />
            <div class="hero-overlay"></div>
          </div>
          <!-- 内容 -->
          <div class="hero-content">
            <div class="hero-inner">
              <div class="hero-tag" v-if="item.tag">{{ item.tag }}</div>
              <h1 class="hero-title">{{ item.title }}</h1>
              <p class="hero-desc">{{ item.description }}</p>
              <div class="hero-actions">
                <a class="hero-btn-primary" @click="goToProduct">查看产品</a>
                <a class="hero-btn-outline" @click="goToContact">联系我们</a>
              </div>
            </div>
          </div>
        </div>
      </CarouselItem>
    </Carousel>

    <!-- 自定义指示器 -->
    <div class="hero-dots">
      <button
        v-for="(item, index) in carouselItems"
        :key="index"
        :class="['hero-dot', { active: activeIndex === index }]"
        @click="activeIndex = index"
      ></button>
    </div>

    <!-- 数据统计条 -->
    <div class="hero-stats">
      <div class="stats-container">
        <div class="stat-item" v-for="stat in stats" :key="stat.label">
          <span class="stat-number">{{ stat.number }}</span>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalCarousel',
  data() {
    return {
      activeIndex: 0,
      carouselHeight: 580,
      carouselItems: [
        {
          src: '/assets/home.jpg',
          alt: '首页',
          tag: '专业制造商',
          title: '欢迎来到柯美自动化',
          description: '专注电容器自动化生产设备研发与制造，为您提供高品质的工业自动化解决方案',
        },
        {
          src: '/assets/about3.png',
          alt: '关于我们',
          tag: '关于我们',
          title: '匠心铸就品质',
          description: '专注于电容器生产设备研发与制造，多年积淀，赢得海内外客户信赖',
        },
        {
          src: '/assets/prod.png',
          alt: '产品中心',
          tag: '产品中心',
          title: '高品质自动化设备',
          description: '涵盖电容器生产、实验及其他配套设备，满足您的全方位需求',
        },
      ],
      stats: [
        { number: '15+', label: '年行业经验' },
        { number: '100+', label: '产品种类' },
        { number: '500+', label: '合作客户' },
        { number: '24h', label: '技术支持' },
      ],
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      const width = window.innerWidth;
      if (width < 480) {
        this.carouselHeight = 360;
      } else if (width < 768) {
        this.carouselHeight = 460;
      } else if (width < 1024) {
        this.carouselHeight = 520;
      } else {
        this.carouselHeight = 580;
      }
    },
    goToProduct() {
      this.$router.push('/prod-list');
    },
    goToContact() {
      this.$router.push('/contact');
    },
  },
};
</script>

<style scoped lang="less">
.km-hero {
  width: 100%;
  position: relative;
  overflow: hidden;
}

/* 幻灯片 */
.hero-slide {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 背景图 */
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.hero-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  filter: brightness(0.7);
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 30, 90, 0.75) 0%, rgba(0, 60, 140, 0.6) 50%, rgba(0, 86, 179, 0.45) 100%);
}

/* 内容区 */
.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
}

.hero-inner {
  max-width: 820px;
  text-align: center;
  animation: heroFadeUp 0.8s ease both;
}

@keyframes heroFadeUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-tag {
  display: inline-block;
  padding: 5px 16px;
  background: rgba(255, 140, 0, 0.9);
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.hero-title {
  font-size: 56px;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 20px;
  line-height: 1.15;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.3);
}

.hero-desc {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 36px;
  line-height: 1.7;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

/* 按钮组 */
.hero-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.hero-btn-primary {
  display: inline-flex;
  align-items: center;
  padding: 14px 36px;
  background: #ff8c00;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-decoration: none;
  box-shadow: 0 4px 20px rgba(255, 140, 0, 0.4);
  letter-spacing: 0.5px;

  &:hover {
    background: #e67e00;
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(255, 140, 0, 0.5);
    color: #ffffff;
  }
}

.hero-btn-outline {
  display: inline-flex;
  align-items: center;
  padding: 12px 34px;
  background: transparent;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.25s ease;
  text-decoration: none;
  letter-spacing: 0.5px;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: #ffffff;
    transform: translateY(-3px);
    color: #ffffff;
  }
}

/* 自定义指示器 */
.hero-dots {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
  z-index: 10;
}

.hero-dot {
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.5);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &.active {
    background: #ff8c00;
    width: 28px;
    border-radius: 4px;
  }
}

/* 统计数据条 */
.hero-stats {
  position: relative;
  z-index: 10;
  background: var(--primary-dark);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.stats-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;

  &:last-child {
    border-right: none;
  }
}

.stat-number {
  font-size: 28px;
  font-weight: 800;
  color: #ff8c00;
  line-height: 1.2;
}

.stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 4px;
  font-weight: 500;
}

/* 隐藏默认dots */
::v-deep .ivu-carousel-dots {
  display: none;
}

/* 响应式 */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 44px;
  }
  .hero-desc {
    font-size: 17px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 34px;
    margin-bottom: 14px;
  }
  .hero-desc {
    font-size: 15px;
    margin-bottom: 28px;
  }
  .hero-tag {
    font-size: 11px;
    margin-bottom: 14px;
  }
  .hero-btn-primary,
  .hero-btn-outline {
    padding: 11px 26px;
    font-size: 14px;
  }
  .hero-dots {
    bottom: 68px;
  }

  .stats-container {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 16px;
  }

  .stat-item {
    padding: 16px 12px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    &:nth-child(2) {
      border-right: none;
    }
    &:nth-child(3) {
      border-bottom: none;
    }
    &:nth-child(4) {
      border-right: none;
      border-bottom: none;
    }
  }

  .stat-number {
    font-size: 24px;
  }
  .stat-label {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 26px;
  }
  .hero-desc {
    font-size: 14px;
  }
  .hero-inner {
    padding: 0 8px;
  }
  .hero-actions {
    gap: 10px;
  }
  .hero-btn-primary,
  .hero-btn-outline {
    padding: 10px 22px;
    font-size: 13px;
  }
  .hero-dots {
    bottom: 56px;
  }
  .stat-number {
    font-size: 20px;
  }
}
</style>
